export default __webpack_public_path__ + "static/media/Ascending.Inactive.66c6b2c2.svg";